// Header.js
import NavBar from "./NavBar";

export default function Header() {
  return (
    <header className="site-header">
      <NavBar />
    </header>
  );
}